import { jsx as _jsx } from "react/jsx-runtime";
import GenericSettingsPage from './GenericSettingsPage';
export default function SectionTypesPage() {
    const columns = [
        { key: 'name', label: 'Name', type: 'text', required: true },
        { key: 'description', label: 'Description', type: 'text', required: false },
        { key: 'sort_order', label: 'Sort Order', type: 'number', required: true, defaultValue: 0 },
    ];
    return (_jsx(GenericSettingsPage, { tableName: "section_types", title: "Section Types", columns: columns, apiPath: "section_types" }));
}
